import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'If Page on Report' },
    { value: 2, label: 'Always' },
    { value: 3, label: 'Never' },
  ],
});
